var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list)?_c('div',{staticClass:"programList_themeItem"},[_c('CompProgramList',{attrs:{"currCid":_vm.currCid,"currSid":_vm.currSid,"currThemeObj":_vm.currThemeObj,"data":_vm.list,"detailPathName":'',"chooseState":'',"themeClass":`onlyDisplay`,"viewMode":'shareAfterView'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }